<template>
  <b-table
    ref="table"
    :items="outputs"
    :fields="fields"
    show-empty
    responsive
    class="mt-n2 loaded"
  >
    <template #cell(presetId)="data">
      <GjIcon
        v-if="hasError(data.item)"
        v-b-tooltip.hover
        :title="getErrorMessage(data.item)"
        name="InfoAlt"
        class="text-danger"
        size="20"
      />
    </template>
    <template #cell(name)="data">
      <a
        class="text-primary"
        @click="openOutput(data.index)"
      >{{
        data.value
      }}</a>
    </template>

    <template #cell(nameModifier)="data">
      <a
        class="text-primary"
        @click="openOutput(data.index)"
      >
        {{
          data.value ? data.value : isHLS || isDash ? '-' : data.item.name
        }}</a>
    </template>

    <template #cell(videoCodec)="data">
      {{ data.value || '-' }}
    </template>

    <template #cell(audioCodec)="data">
      {{ data.value || '-' }}
    </template>
    <template
      #cell(id)="data"
      width="20"
    >
      <a
        class="p-1 text-danger"
        @click="removeOutput(data.index)"
      >
        <GjIcon
          name="Delete"
          class="text-danger"
          size="23"
        />
      </a>
    </template>

    <template #empty>
      <div class="text-center py-1">
        <no-data
          no-data-text="No outputs created"
          create-text="Start by adding an output"
        />
      </div>
    </template>
  </b-table>
</template>

<script>
export default {
  name: 'OutputsTable',
  props: {
    outputs: {
      type: Array,
      // eslint-disable-next-line no-array-constructor
      default: () => [],
    },
    isHLS: {
      type: Boolean,
      required: true,
    },
    isDash: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      fieldsData: [
        { key: 'presetId', label: '' },
        { key: 'name', label: 'Folder Name' },
        { key: 'nameModifier', label: 'File Name' },
        { key: 'videoCodec', label: 'video' },
        { key: 'audioCodec', label: 'audio' },
        { key: 'presetId', label: '' },
        { key: 'id', label: '' },
      ],
    }
  },
  computed: {
    fields() {
      return this.isHLS || this.isDash
        ? this.fieldsData
        : this.fieldsData.filter(field => field.key !== 'name')
    },
    tableData() {
      return this.outputs.map(o => ({
        ...o,
      }))
    },
  },
  methods: {
    getVideoCodecType(obj) {
      if (obj.presetId) {
        return obj.videoDescription ? obj.videoDescription.codecType : '-'
      }
      return '-'
    },
    getAudioCodecType(obj) {
      if (obj.presetId) {
        return obj.audioDescription ? obj.audioDescription.codecType : '-'
      }
      return '-'
    },
    openOutput(index) {
      this.$emit('editOutput', index)
    },
    removeOutput(index) {
      this.$emit('removeOutput', index)
    },
    hasError(item) {
      if (!item.presetId) return true
      if (this.tableData.length > 1) {
        if (this.isHLS || this.isDash) {
          if (this.hasDuplicateFolderName(item.name)) {
            return (
              !item.nameModifier || this.hasDuplicateName(item.nameModifier)
            )
          }
          return false
        }
        if (item.nameModifier) {
          return this.hasDuplicateName(item.nameModifier)
        }
        return true
      }
      return false
    },
    getErrorMessage(item) {
      if (!item.presetId) {
        return 'You have to select a preset for this output'
      }
      if (this.tableData.length > 1 && !item.nameModifier) {
        return 'You have to set a unique name for this output'
      }
      if (
        (!this.isHLS || !this.isDash)
        && this.hasDuplicateName(item.nameModifier)
      ) {
        return 'File name has to be unique.'
      }
      if (
        (this.isHLS || this.isDash)
        && this.hasDuplicateFolderName(item.name)
        && this.hasDuplicateName(item.nameModifier)
      ) {
        return 'File name has to be unique'
      }
      return ''
    },
    isDuplicate(item, array) {
      const index = array.findIndex(el => el.id === item.id)
      const sliced = [...array].slice(index, 1)
      return sliced.find(el => el.nameModifier === item.nameModifier)
    },
    hasDuplicateName(name) {
      const removeByName = this.tableData.filter(o => o.nameModifier !== name)
      const dif = this.tableData.length - removeByName.length
      return dif > 1
    },
    hasDuplicateFolderName(name) {
      const removeByName = this.tableData.filter(o => o.name !== name)
      const dif = this.tableData.length - removeByName.length
      return dif > 1
    },
  },
}
</script>
